module.exports = __webpack_public_path__ + "img/nvquan.ae93d763.png";